document.addEventListener('DOMContentLoaded', function () {
    console.log('===========>>>>>>...')
    const ingredientSections = document.querySelectorAll('[data-section-id]');
    ingredientSections.forEach(section => {
        const sectionId = section.getAttribute('data-section-id');
        const swiperSelector = `.section-${sectionId} .swiper-ingredients`;
        new Swiper(swiperSelector, {
            slidesPerView: 1,
            spaceBetween: 4,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            grabCursor: true,
            loop: false,
            centerInsufficientSlides: true,
            keyboard: {
                enabled: true,
            },
            //mousewheel: true,
            navigation: {
                nextEl: `.section-${sectionId} .swiper-button-next`,
                prevEl: `.section-${sectionId} .swiper-button-prev`,
            },
            breakpoints: {
                1300: {
                    slidesPerView: 4,
                    spaceBetween: 8,
                    slidesPerGroup: 4,
                },
                850: {
                    slidesPerView: 3,
                    spaceBetween: 8,
                    slidesPerGroup: 3,
                },
                600: {
                    slidesPerView: 2,
                    spaceBetween: 8,
                    slidesPerGroup: 2,
                },
                300: {
                    slidesPerView: 1,
                    spaceBetween: 4,
                    slidesPerGroup: 1,
                    centeredSlides: true,
                },
            },
        });
    });
    console.log('===========>>>>>>...2')
});